/* eslint-disable import/no-anonymous-default-export */

import Error from "./error";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../mixpanel";
import { transformPath } from "../App";
import createAxios from "./httpCommon";

import mixpanel from "mixpanel-browser";

import {
  localStorageGetItem,
  localStorageSetItem,
  localStorageRemoveItem,
} from "../App";
import { trackCompleteRegistration } from "./tracking";
import {
  trackOmnisendLoginFailure,
  trackOmnisendLoginSuccess,
} from "../omnisend";

// Check if running on localhost
const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";
export default () => {
  const { error } = Error();
  const navigate = useNavigate();

  const signup = (
    body,
    setLoading,
    showToast,
    setFormData,
    setShowVerificationModal,
  ) => {
    setLoading(true);
    createAxios().then((axios) => {
      axios
        .post("/auth/register", body)
        .then(async (response) => {
          setLoading(false);

          const gotResponse = response?.data?.data;
          if (gotResponse) {
            const userId = gotResponse?.user?.id;
            const email = gotResponse?.user?.email;
            const name = `${gotResponse?.user?.firstName} ${gotResponse?.user?.lastName}`;
            const phoneNumber = gotResponse?.user?.phoneNumber || "";
            const preAuthPath = localStorageGetItem("preAuthPath");

            const user = {
              id: gotResponse.user.id,
              email: gotResponse.user.email,
              firstName: gotResponse.user.firstName,
              lastName: gotResponse.user.lastName,
              phoneNumber: gotResponse.user.phoneNumber || "",
              customProperties: {
                leadSource: gotResponse.user.leadSource,
              },
            };

            if (!isLocalhost) {
              // Standard Mixpanel identify/alias flow
              if (mixpanel.get_distinct_id() !== userId) {
                mixpanel.alias(userId);
              }
              mixpanel.identify(userId);

              mixpanel.people.set({
                $email: email,
                $phone: phoneNumber,
                $name: name,
                created_at: new Date().toISOString(),
              });

              trackEvent("Successful Signup", {
                userid: userId,
                email_address: email,
                phone_number: phoneNumber,
                leadSource: gotResponse?.user?.leadSource,
                signup_type: "email",
                referralCode: body?.referralCode || "none",
                signup_at: new Date().toISOString(),
                signup_location: transformPath(preAuthPath),
                button_clicked: "Create an account",
              });

              trackCompleteRegistration("success", email, name, "Signup");
            }
            localStorageSetItem("userData", JSON.stringify(gotResponse.user));
            localStorageSetItem("userToken", gotResponse?.accessToken);

            setFormData({
              firstName: "",
              lastName: "",
              email: "",
              password: "",
              confirmPassword: "",
            });

            setShowVerificationModal(true);
          } else {
            showToast({
              toastText: "Failed to register",
              isSuccess: false,
            });
          }
        })

        .catch((e) => {
          // setLoading(false);
          const retriesDone = e?.config?.["axios-retry"]?.retryCount >= 1;
          const preAuthPath = localStorageGetItem("preAuthPath") || "/";
          trackEvent("Failed Signup", {
            email_address: body.email,
            failure_reason:
              e.response?.data?.message ||
              e.message ||
              "An unexpected error occurred",
            signup_location: transformPath(preAuthPath),
            attempted_at: new Date().toISOString(),
            button_clicked: "Create an account",
          });
          const failureReason =
            e?.response?.data?.message ||
            e?.message ||
            "An unexpected error occurred";
          trackCompleteRegistration(
            `failure- ${failureReason}`,
            body?.email,
            "",
            "Signup",
          );
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  const updatePassword = (setLoading, body, showToast) => {
    setLoading(true);
    const token = localStorageGetItem("userToken");
    createAxios().then((axios) => {
      axios
        .patch("/auth/update-password", body, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then(async (response) => {
          setLoading(false);
          if (response.status === 200) {
            showToast({
              toastText: "Password updated successfully",
              isSuccess: true,
            });

            navigate("/");
          }
        })

        .catch((e) => {
          // setLoading(false);
          let retryCount = 0;

          if (e && e.config && e.config["axios-retry"]) {
            retryCount = e.config["axios-retry"].retryCount || 0;
          }

          const retriesDone = retryCount >= 1;

          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  const login = (body, setLoading, showToast, setEmail, setPassword) => {
    setLoading(true);
    createAxios().then((axios) => {
      axios
        .post("/auth/login", body)
        .then(async (response) => {
          setLoading(false);

          const gotResponse = response?.data?.data;

          if (gotResponse) {
            localStorageSetItem("userData", JSON.stringify(gotResponse?.user));
            localStorageSetItem("userToken", gotResponse?.accessToken);

            const preAuthPath = localStorageGetItem("preAuthPath");

            const userId = gotResponse?.user?.id;
            const email = gotResponse?.user?.email;
            const name = `${gotResponse?.user?.firstName} ${gotResponse?.user?.lastName}`;
            const phoneNumber = gotResponse?.user?.phoneNumber || "";
            const user = {
              id: gotResponse.user.id,
              email: gotResponse.user.email,
              firstName: gotResponse.user.firstName,
              lastName: gotResponse.user.lastName,
              phoneNumber: gotResponse.user.phoneNumber || "",
            };
            if (!isLocalhost) {
              mixpanel.identify(userId);

              mixpanel.people.set({
                $email: email,
                $phone: phoneNumber,
                $name: name,
              });
            }

            trackEvent("Successful Login", {
              email_address: email,
              login_type: "email",
              login_at: new Date().toISOString(),
              login_location: transformPath(preAuthPath),
              button_clicked: "Sign in",
              device_type: navigator.userAgent,
            });

            trackCompleteRegistration(
              "success",
              gotResponse?.user?.email,
              name,
              "Login",
            );
            // Omnisend: identify first, then track success
            trackOmnisendLoginSuccess(user);

            setEmail("");
            setPassword("");

            if (preAuthPath) {
              navigate(preAuthPath);
            } else {
              navigate("/");
            }
            showToast({
              toastText: "Welcome back!",
              isSuccess: true,
            });
            localStorageRemoveItem("preAuthPath");
          } else {
            showToast({
              toastText: "Failed to login!",
              isSuccess: false,
            });
          }
        })
        .catch((e) => {
          const preAuthPath = localStorageGetItem("preAuthPath") || "/";
          trackEvent("Failed Login", {
            email_address: body.email,
            failure_reason:
              e.response?.data?.message ||
              e.message ||
              "An unexpected error occurred",
            login_location: transformPath(preAuthPath),
            attempted_at: new Date().toISOString(),
            button_clicked: "Sign in",
          });
          const failureReason =
            e?.response?.data?.message ||
            e?.message ||
            "An unexpected error occurred";
          trackCompleteRegistration(
            `failure- ${failureReason}`,
            body?.email,
            "",
            "Login",
          );

          trackOmnisendLoginFailure(body.email, failureReason);

          let retryCount = 0;

          if (e && e.config && e.config["axios-retry"]) {
            retryCount = e.config["axios-retry"].retryCount || 0;
          }

          const retriesDone = retryCount >= 1;

          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  const trackVisit = (body, showToast) => {
    createAxios().then((axios) => {
      axios
        .post("/user/track-web-visit", body)
        .then(async (response) => {})
        .catch((e) => {
          const retriesDone = e?.config?.["axios-retry"]?.retryCount >= 1;
          error(e, showToast, retriesDone);
        });
    });
  };

  const resetForgotPassword = (setLoading, body, showToast) => {
    setLoading(true);

    createAxios().then((axios) => {
      axios
        .patch("/auth/reset-password", body)
        .then(async (response) => {
          setLoading(false);
          if (response.status === 200) {
            setLoading(false);
            const gotResponse = response?.data?.data;

            localStorageSetItem("userToken", gotResponse?.accessToken);
            localStorageSetItem("userData", JSON.stringify(gotResponse?.user));
            trackEvent("Reset Password successful", {
              userid: gotResponse?.user?.id,
              email_address: gotResponse?.user?.email,
              phone_number: gotResponse?.user?.phoneNumber || "",
            });
            showToast({
              toastText: "Password reset successfully",
              isSuccess: true,
            });

            navigate("/");
          }
        })

        .catch((e) => {
          setLoading(false);
          trackEvent("Failed Password reset", {
            failure_reason:
              error?.response?.data?.message ||
              error?.message ||
              "An unexpected error occurred",
          });
          let retryCount = 0;

          if (e && e.config && e.config["axios-retry"]) {
            retryCount = e.config["axios-retry"].retryCount || 0;
          }

          const retriesDone = retryCount >= 1;

          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  const sendPasswordResetLink = (body, showToast) => {
    createAxios().then((axios) => {
      axios
        .post("/auth/password-reset-link/request", body)
        .then(async (response) => {
          const gotResponse = response?.data?.data;

          if (gotResponse) {
            showToast({
              toastText: "Password Reset link has been sent to your email!",
              isSuccess: true,
            });
            navigate("/login");
          } else {
            showToast({
              toastText: "Failed to send reset link!",
              isSuccess: false,
            });
          }
        })
        .catch((e) => {
          const retriesDone = e?.config?.["axios-retry"]?.retryCount >= 1;
          error(e, showToast, retriesDone);
        });
    });
  };

  const resendVerification = (
    setLoading,
    showToast,
    setShowVerificationModal,
  ) => {
    setLoading(true);
    const token = localStorageGetItem("userToken");
    createAxios().then((axios) => {
      axios
        .get("/auth/email-verification/request", {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then(async (response) => {
          setLoading(false);

          setShowVerificationModal(true);
        })

        .catch((e) => {
          // setLoading(false);
          let retryCount = 0;

          if (e && e.config && e.config["axios-retry"]) {
            retryCount = e.config["axios-retry"].retryCount || 0;
          }

          const retriesDone = retryCount >= 1;

          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  return {
    login,
    signup,
    updatePassword,
    sendPasswordResetLink,
    resetForgotPassword,
    resendVerification,
    trackVisit,
  };
};
